import { VFolder, VFolderId, VFolderState } from '@webinex/clippo';
import { baseApi, RtkqRequest } from '@app/base';
import { VRowData, VRowMeta } from './commonTypes';
import { clippoHttp } from './clippo';

const commonApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getFiles: build.query<VFolder<VRowMeta, VRowData> | null, RtkqRequest<VFolderId>>({
      queryFn: (args) => clippoHttp.byId(args).then((x) => ({ data: x })),
      providesTags: (result) => [{ type: 'main:file', id: result ? `${result.type}::${result.id}` : 'none' }],
    }),
    updateFiles: build.mutation<VFolder<VRowMeta, VRowData> | null, RtkqRequest<VFolderState<VRowData>>>({
      queryFn: (args) => clippoHttp.save(args).then((x) => ({ data: x })),
      invalidatesTags: (_, __, { id, type }) => [
        { type: 'main:file', id: `${type}::${id}` },
        { type: 'main:file', id: 'none' },
      ],
    }),
  }),
});

export const { useGetFilesQuery, useLazyGetFilesQuery, useUpdateFilesMutation } = commonApi;
